import {validateField} from '../helpers/validation'

export function validate(field) {
  field = validateField(field)
  return {
    type: 'VALIDATE',
    field
  }
}

export function submit(fields) {
  fields = fields.map(field => validateField(field))
  return {
    type: 'SUBMIT',
    fields
  }
}
